( function ( _s ) {
	const copyURL = _link => {
		if ( ! _link.length ) return;

		const urlToCopy = _link.attr( 'href' );

		// Use the Clipboard API to copy the URL
		navigator.clipboard.writeText( urlToCopy ).then(
			function () {
				_link.addClass( 'copied' );

				setTimeout( () => {
					_link.removeClass( 'copied' );
				}, 3000 );
			},
			function ( err ) {
				console.error( 'Failed to copy the URL: ', err );
			}
		);
	};

	_s.fn.shareButtons = function () {
		return this.each( el => {
			const _self = _s( el );
			const _links = _self.find( '.link-wrapper' );

			if ( navigator.clipboard ) {
				_links
					.filter( '.copy' )
					.addClass( 'has-browser-support' )
					.find( 'a' )
					.on( 'click', e => {
						e.preventDefault();
						copyURL( _s( e.target ) );
					} );
			}

			_self.addClass( 'initialized' );
		} );
	};

	_s( document ).ready( () => {
		_s( '.fr-share-buttons' ).shareButtons();
	} );
} )( window._s );
